import React from 'react'
import DisplaysMethods, { IDisplaysProps } from './displays.local.methods'
import Content from 'blocks.app/content/content'
import Modal from 'blocks.simple/modal/modal'
import Catalog from 'blocks.app/catalog/catalog'
import DisplaysToolbar from './__toolbar/displays__toolbar'
import { connect } from 'react-redux'
import translate from 'core/translate'
import helpers from 'core/helpers'
import helpersDisplays from 'core/helpers/_digitalSignages'
import { cn } from 'ethcss'
import styles from './displays.jcss'
import { getURLSearchParamsByLocation } from 'features/routes/utils'
import { displaysActions, downloadLogsLink, getDisplaysWithoutAddress, openApprove } from './displays.state'
import { getParamsForLink } from 'core/helpers/user'
import { isHorizontalMenu } from '../../core/helpers/menu'
import { withWindowResize } from 'core/hocs'
import { checkAvailableModule } from '../../core/helpers/routes/routes'
import { TagShortModel } from '../../core/models/Tags'
import { IDevice } from '../../core/models/DigitalSignage'
import ModalWithBackground from 'blocks.simple/modalWithBackground/modalWithBackground'
import DisplaysMoveSettings from './__moveSettings/displays__moveSettings'

const Displays = (p_: IDisplaysProps) => {
    const {
        state,
        setState,
        onSelectInfo,
        getDisposition,
        onSelectItems,
        onGetFoldersOnMultiple,
        onSelect,
        onGetTags,
        mapSelect,
        onCatalogChange,
        onDoubleClickObject,
        modalOptions,
        onMapUnselect,
        renderModalContent,
        onCloseMoveSettings,
    } = DisplaysMethods(p_)

    const params = getParamsForLink(p_.tokens, p_.mainUser.id, p_.user.id)
    const downloadLink =
        helpersDisplays.getDownloadLink(state.selectedInfo ? [state.selectedInfo] : state.selectedItems, params) || ''
    const query = getURLSearchParamsByLocation(p_.location)
    const parsedQuery = helpers.getQuery(query, 'displays')
    const disposition = getDisposition()
    const groupId = parsedQuery.groupId ? parseInt(parsedQuery.groupId, 10) : null

    return (
        <Content
            title={translate('devices')}
            className={p_.className}
            toolbar={
                <DisplaysToolbar
                    query={query}
                    selectedInfo={state.selectedInfo}
                    selectedItems={state.selectedItems}
                    groups={p_.groups}
                    groupId={groupId}
                    onSelectInfo={onSelectInfo}
                    onCloseInfo={() =>
                        setState((prevState) => {
                            return {
                                ...prevState,
                                selectedInfo: null,
                            }
                        })
                    }
                    onChange={onSelectItems}
                    onGetFoldersOnMultiple={onGetFoldersOnMultiple}
                    downloadLink={downloadLink}
                />
            }
            toolbarClassName={styles.toolbar}
            indentsMod={disposition === 'map' ? 'none' : null}
        >
            <Catalog
                key={'displays__catalog'}
                type={'displays'}
                disposition={disposition}
                selectedInfo={state.selectedInfo}
                onSelectInfo={onSelectInfo}
                selectedItems={state.selectedItems}
                onSelect={onSelect}
                onDoubleClickObject={onDoubleClickObject}
                onGetTags={onGetTags}
                breadcrumbsClassName={cn(styles.breadcrumbs, {
                    [styles.breadcrumbs_x]: isHorizontalMenu() && p_.windowWidth > 960,
                })}
                mapSelect={mapSelect}
                onChange={onCatalogChange}
                mapUnselect={onMapUnselect}
                fixedHeader
                wrapperClassName={cn(styles.displaysWrapper, {
                    [styles.isMapModeDisplaysWrapper]: disposition === 'map' && p_.isMobilePage && !isHorizontalMenu(),
                })}
                viewTestClass={'test-device-display'}
            />
            <Modal
                open={p_.modalState}
                onClose={function () {
                    p_.closeModal()
                }}
                {...p_.modalOptions}
                mod={modalOptions.mod || modalOptions.style}
                closeIconStyles={p_.modalState === 'approve' ? modalOptions.closeIconStyles : null}
                showCloseIcon={
                    p_.modalState !== 'infoDisplay' &&
                    p_.modalState !== 'displaySettings' &&
                    p_.modalState !== 'remoteDeviceControl' &&
                    modalOptions.showCloseIcon
                }
            >
                {renderModalContent()}
            </Modal>
            <ModalWithBackground isOpen={p_.moveSettingsModal.isOpen} onClose={onCloseMoveSettings}>
                <DisplaysMoveSettings data={p_.moveSettingsModal} />
            </ModalWithBackground>
        </Content>
    )
}

const mapStateToProps = (state: any) => ({
    modalState: state.displays.modalState,
    modalOptions: state.displays.modalOptions,
    tags: state.displays.tags,
    groups: state.displays.groups,
    minimize: state.app.minimizeMenu,
    tokens: state.user.tokens,
    user: state.user.data,
    mainUser: state.user.mainUser,
    isConnected: state.displays.isConnected,
    isMobilePage: state.app.isMobile,
    moveSettingsModal: state.app.moveSettingsModal,
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        closeModal: () => dispatch(displaysActions.closeModal()),
        getDisplaysWithoutAddress: () => dispatch(getDisplaysWithoutAddress()),
        setTags: (tags: TagShortModel[]) => dispatch(displaysActions.setTags(tags)),
        setGroups: (tags: IDevice[]) => dispatch(displaysActions.setGroups(tags)),
        clearMap: () => dispatch(displaysActions.clearMap()),
        clearState: () => dispatch(displaysActions.clearState()),
        downloadLogsLink: (res: any) => dispatch(downloadLogsLink(res)),
        openApprove: (code: string) => dispatch(openApprove(code)),
    }
}

const exportDisplays = checkAvailableModule('displays')
    ? connect(mapStateToProps, mapDispatchToProps)(withWindowResize(Displays))
    : null

export default exportDisplays
